module.exports = __webpack_public_path__ + "static/media/thumbnail.fbe23a99.jpg";